import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {getFacility} from "../../api/apiClient";


const ComboFclty = ({
                      propFilterDist = '',
                      propLabel = '시설명',
                      propOnChange = null,
                      propLabelRatio,
                      propLocation = 'SEARCH',
                      propValue
                    }) => {

  /* 시설 목록 data */
  const [stFcltyList, setFcltyList] = useState([]);

  /* 시설 목록 갱신 */
  const updateFcltyList = () => {
    getFacility(propFilterDist)
        .then((res) => {
              // console.log(res.data.data.list);
              setFcltyList(res.data.data.list);
            }
        );
  };

  useEffect(() => {
    updateFcltyList();
  }, [propFilterDist]);

  return (
      /*<Form.Group as={Row} controlId="formBasicSelectMenu">
        <Form.Label column sm={propLabelRatio}
                    className={`label text-end ${propLocation === "SEARCH" ? "" : "fw-bold"} `}>
          {propLocation === 'SEARCH' ? '' : <span className={"text-danger"}>* </span>}{propLabel}
        </Form.Label>
        <Col sm={12 - propLabelRatio} className={""}>
          <Form.Select
              aria-label="Fclty Select"
              className={"input-select"}
              onChange={propOnChange}
              defaultValue={propValue}
              key={propValue}
          >
            <option value={""}>
              {propLocation === 'SEARCH' ? '전체' : '선택'}
            </option>
            {Array.isArray(stFcltyList) ?
                (stFcltyList.map((elem, idx) => {
                  return (
                      <option key={idx} value={elem.cd}>{elem.nm}</option>
                  )
                })) : ''}
          </Form.Select>
        </Col>
      </Form.Group>*/
      <Form.Group as={Row} controlId="formBasicSelectMenu">
        <Form.Label
            className={`col-form-label label text-end ${propLocation === "SEARCH" ? "" : "fw-bold"}`}
            style={propLabelRatio ? {} : {width: "100px"}}
            column={propLabelRatio ? true : false}
            sm={propLabelRatio}
        >
          {propLocation === 'SEARCH' ? '' : <span className={"text-danger"}>* </span>}{propLabel}
        </Form.Label>
        <Col md={propLabelRatio ? 12 - `${propLabelRatio}` : ''} className={""}>
          <Form.Select
              aria-label="Fclty Select"
              className={"input-select"}
              onChange={propOnChange}
              defaultValue={propValue}
              key={propValue}
          >
            <option value={""}>
              {propLocation === 'SEARCH' ? '전체' : '선택'}
            </option>
            {Array.isArray(stFcltyList) ?
                (stFcltyList.map((elem, idx) => {
                  return (
                      <option key={idx} value={elem.cd}>{elem.nm}</option>
                  )
                })) : ''}
          </Form.Select>
        </Col>
      </Form.Group>
  );
}

export default ComboFclty;





